function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "26lc47wp8a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3701",
    style: {
      fill: "#032541"
    },
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1505",
    cx: 17,
    cy: 17,
    r: 17,
    style: {
      fill: "#f5f6f7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#26lc47wp8a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.637 80.8a9.219 9.219 0 0 0-7.137 9.06.821.821 0 1 0 1.641 0 7.388 7.388 0 1 1 14.77 0 .821.821 0 1 0 1.641 0 9.219 9.219 0 0 0-7.137-9.06 5.36 5.36 0 0 0 3.33-5 5.221 5.221 0 1 0-10.438 0 5.36 5.36 0 0 0 3.33 5zm1.889-8.664a3.671 3.671 0 1 1-3.578 3.669 3.626 3.626 0 0 1 3.578-3.667z",
    transform: "translate(-149.616 -63.669)",
    style: {
      fillRule: "evenodd",
      fill: "#032541"
    },
    "data-name": "Mask Group 706"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.360f7deae2b9118288e45654e04c269d.svg";
export { ForwardRef as ReactComponent };